import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";


function WaterLevelChart({ history = [], distance }) {
  const data =
    history.length > 0
      ? history.map((entry) => ({
          time: new Date(entry.time).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          }),
          distance: entry.value,
        }))
      : [{ time: "00:00", distance: 0 }]; // fallback point for initial render
  return (
    <div
      className="card p-2 mt-2 position-relative"
      style={{ backgroundColor: "#0d1117", borderRadius: "12px" }}
    >
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6 className="text-light mb-0">Distance</h6>
        <h6 className="text-success mb-0">
          {distance ?? 0} <small>cm</small>
        </h6>
      </div>

      <ResponsiveContainer width="100%" height={180}>
        <LineChart data={data} margin={{ top: 5, right: 20, left: -10, bottom: 5 }}>
          <CartesianGrid stroke="#444" strokeDasharray="3 3" />
          <XAxis dataKey="time" stroke="#aaa" tick={{ fontSize: 10 }} />
          <YAxis
            domain={[0, "auto"]}
            label={{
              value: "Distance (cm)",
              angle: -90,
              position: "insideLeft",
              style: { fill: "#ccc", fontSize: 10 },
            }}
            tick={{ fill: "#ccc", fontSize: 10 }}
          />
          <Tooltip formatter={(value) => `${value} cm`} />
          <Legend wrapperStyle={{ fontSize: 10 }} />
          <Line
            type="monotone"
            dataKey="distance"
            stroke="#FFD700"
            strokeWidth={2}
            dot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}

export default WaterLevelChart;

